import script from "./ExCuartoFrio.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExCuartoFrio.vue?vue&type=script&setup=true&lang=ts"

import "./ExCuartoFrio.vue?vue&type=style&index=0&id=b2a87372&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2a87372"]])

export default __exports__